import { useEffect } from 'react';

import useDevice from '@hooks/useDevice';

/* Windows has heavy native scrollbars — on Windows we opt into the slim custom
 * scrollbars defined under `.win-scrollbars` in src/index.css. (Replaces the
 * old styled-components createGlobalStyle.) */
const WindowsScrollbars: React.FC = () => {
  const { platform } = useDevice();

  useEffect(() => {
    const isWindows = !!platform && platform.toLowerCase().includes('win');
    if (!isWindows) return;
    document.documentElement.classList.add('win-scrollbars');
    return () => document.documentElement.classList.remove('win-scrollbars');
  }, [platform]);

  return null;
};

export default WindowsScrollbars;
